import { FC } from 'react';

import styles from './styles.module.scss';

export const SkeletonSchedule: FC = () => {
  const columns = [
    4, 3, 2, 5, 2, 3, 5, 2, 1, 3, 4, 3, 2, 5, 2, 3, 5, 2, 1, 3, 5, 2, 3, 5, 2,
  ];

  return (
    <div className={styles['skeleton-schedule']}>
      {columns.map((cardsCount, columnIndex) => (
        <div key={columnIndex} className={styles['skeleton-schedule__column']}>
          {Array(cardsCount)
            .fill(null)
            .map((_, cardIndex) => (
              <div
                key={cardIndex}
                className={styles['skeleton-schedule__card']}
              />
            ))}
        </div>
      ))}
    </div>
  );
};
